/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import MultiSelectForm from 'components/Common/ElementInForm/MultiSelectForm';




am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);


const TotalVOCBarChart = (props) => {

    const { sBA, data, IsExport,optionAll,exportImg,onLoadGraphTotolDiv1,IsSearch } = props


    const schema = yup.object().shape({
        oTypeyear: yupFormSchemas.object(`type display`, { required: false }),
    });

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        form.setValue("oTypeyear", { value: "9999", label: "ทั้งหมด" })
    }, [IsSearch])
    

    useEffect(() => {
        if (data != null) {

            GraphStackClusteredBar(data || [])
        }
    }, [data,optionAll])



    const GraphStackClusteredBar = async (data) => {
        // Create chart instance
        let chart = am4core.create("chart-summary-voc", am4charts.XYChart);
        // chart.exporting.menu = new am4core.ExportMenu();

        // Add data
        chart.data = data.lstdata;

        chart.colors.list = [
            am4core.color("#00b050"),
            am4core.color("#ffc000"),
        ];

       
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis()) as any;
        categoryAxis.dataFields.category = "name";
        // categoryAxis.renderer.labels.template.propertyFields.html = "name";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 20;

        categoryAxis.renderer.labels.template.adapter.add("textOutput", function(text) {
                return (text || "").replace("_CMM", "").replace("_GSM", "").replace("_NGR", "").replace("_NGV", "");
          });

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "จำนวนใบงาน";
        valueAxis.renderer.ticks.template.disabled = true;
        valueAxis.renderer.axisFills.template.disabled = true;
        valueAxis.renderer.grid.template.disabled = true;

        // Create series
        function createSeries(field, name, stacked, sTooltip) {
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "name";
            series.name = name;
            series.columns.template.tooltipText = sTooltip + ": [bold]{valueY}[/]";
            series.stacked = stacked;
            // series.columns.template.width = am4core.percent(80);
            // series.columns.template.fillOpacity = 0.9;

            // Add label
            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = "{valueY}";
            labelBullet.locationY = 0.5;
            labelBullet.label.hideOversized = true;
        }

        createSeries("valueComp", "Complaint", true, "ปิดแล้ว");
        createSeries("valueInves", "Request", true, "กำลังดำเนินการ");

        // Label Cluster
        (data.lstLabel || []).forEach(item => {
            let range = categoryAxis.axisRanges.create();
            range.category = item.start;
            range.endCategory = item.end;
            range.label.text = item.label;
            range.label.fill = am4core.color("#000000");
            // range.label.disabled = false;
            range.label.location = 0;
            // range.label.dx = -170;
            range.label.dy = 20;
            // range.label.rotation = 270;
            range.label.fontWeight = "bold";
            range.label.fontSize = 14;
            range.label.horizontalCenter = "middle"
            range.label.inside = false;

            range.grid.stroke = am4core.color("#ffffff");
            range.grid.strokeOpacity = 1;
            range.tick.length = 200;
            range.tick.disabled = true;
            range.tick.strokeOpacity = 0.6;
            range.tick.stroke = am4core.color("#ffffff");
            range.tick.location = 0;
            range.locations.category = 1;
        });

        let img;
        img = await chart.exporting.getImage( "png" );
        setTimeout(() => {
            let obj = {
                id: 1,
                sDesc: "summaryVOC",
                sName: "จำนวนใบงานรวม",
                idDiv: 1,
                imgBase64: img
            }
            if(exportImg)
            {
               exportImg(obj);
            }
        }, 2000);
       

        // if (IsExport == true) {
        //     setTimeout(() => {
        //         chart.exporting.getImage("png").then((data) => {
        //             let obj = {
        //                 id: 1,
        //                 sDesc: "summaryVOC",
        //                 sName: "จำนวนใบงานรวม",
        //                 idDiv: 1,
        //                 imgBase64: data
        //             }
        //             props.exportImg && props.exportImg(obj);
        //         });
        //     }, 2000);
        // }
        return chart;

    }


    return (
        <>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                <Grid item xs={12}>
                    <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center" >
                        <Grid item xs={12} sm={4} md={2}>
                            <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <FormProvider {...form}>
                                <AutoCompleteSelect
                                    name="oTypeyear"
                                    options={optionAll?.optionAllMonthYear || []}
                                    required={false}
                                    disableClearable={true}
                                    IsRadius={true}
                                    onChange={(oValue) => { 
                                        if(oValue)
                                        {
                                            let param ={ "valueSearch" : oValue?.value ?? null}
                                            onLoadGraphTotolDiv1(param)
                                        }
                                   
                                    }}
                                    
                                />
                            </FormProvider>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" >
                        <Grid item xs={12} sm={'auto'}>
                            <div className='div-border-card' style={{ backgroundColor: '#0ac7e4' }}>
                                <Typography className='div-card-title'>รวม</Typography>
                                <Typography className='div-card-value'>{data != null ? data?.nTotal : 0}</Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={'auto'}>
                            <div className='div-border-card' style={{ backgroundColor: '#00b050' }}>
                                <Typography className='div-card-title'>ปิดแล้ว</Typography>
                                <Typography className='div-card-value'>{data != null ? data?.nComplete : 0}</Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={'auto'}>
                            <div className='div-border-card' style={{ backgroundColor: '#ffc000' }}>
                                <Typography className='div-card-title'>กำลังดำเนินการ</Typography>
                                <Typography className='div-card-value'>{data != null ? data?.nInvestigate : 0}</Typography>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <div id="chart-summary-voc" style={{ width: "100%", height: "400px" }}></div>
                </Grid>
            </Grid>
        </>
    )
}

export default TotalVOCBarChart